import { purchaseOrder } from "./purchaseOrder";

export const purchaseOrderService = {
  purchaseOrder,
};
